import { Button, Form } from 'antd';
import { useState } from 'react';
import { $Formutil, withForm } from 'react-antd-formutil';
import { useNavigate } from 'react-router-dom';
import Toast from 'app/components/Toast';
import APP from 'app/stores/APP';
import security from 'app/stores/security';
import Card, { CardButtonWrap } from 'components/Card';
import Password from 'components/forms/Password';
import API from 'utils/API';
import http from 'utils/http';

interface SetPasswordProps {
    $formutil: $Formutil<{
        login_password: string;
        confirm_password: string;
    }>;
}

const SetPassword: React.FC<SetPasswordProps> = ({ $formutil }) => {
    const [loading, setLoading] = useState<boolean>(false);
    const navigete = useNavigate();

    const handleSubmit = async () => {
        const { $params, $invalid, $getFirstError, $batchDirty } = $formutil;

        if ($invalid) {
            Toast.show($getFirstError());
            $batchDirty(true);
        } else {
            setLoading(true);

            try {
                const params = { ...$params };

                delete (params as any).confirm_password;

                await http.post(API.OAUTH.setPassword(), params);
                APP.trackEvent('安全中心', '登录密码_设置', '登录密码设置_设置新密码');
                await security.getStatus();

                navigete('/profile/security');
            } catch (error) {
                Toast.show(error);
            }

            setLoading(false);
        }
    };

    return (
        <Card form>
            <h2>{__('登录密码设置')}</h2>
            <div className="set-password-root">
                <Form layout="vertical" onFinish={handleSubmit}>
                    <Password />
                    <CardButtonWrap>
                        <Button
                            size="large"
                            type="primary"
                            loading={loading}
                            disabled={$formutil.$invalid}
                            htmlType="submit">
                            {__('确定')}
                        </Button>
                    </CardButtonWrap>
                </Form>
            </div>
        </Card>
    );
};

export default withForm(SetPassword);
